import React, { useMemo } from 'react';
import { BoxArrowUpRight } from 'react-bootstrap-icons';
import AutoGrowTextArea from './AutoGrowTextArea';

const URL_REGEX = /((?:https?:\/\/|www\.)[^\s]+)/gi;

const cleanUrl = raw => {
  if (!raw) return { url: '', href: '' };
  const url = raw.replace(/[.,!?;:)]+$/, '');
  const href = /^https?:\/\//i.test(url) ? url : `https://${url}`;
  return { url, href };
};

export const LinkifiedText = ({ text }) => {
  if (!text) return null;

  return (
    <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
      {text.split(/((?:https?:\/\/|www\.)[^\s]+)/gi).map((part, index) => {
        if (!/^(?:https?:\/\/|www\.)/i.test(part)) return part;

        const { url, href } = cleanUrl(part);
        return (
          <React.Fragment key={`${href}-${index}`}>
            <a href={href} target="_blank" rel="noopener noreferrer" dir="ltr" onClick={e => e.stopPropagation()}>
              {url}
            </a>
            {part.slice(url.length)}
          </React.Fragment>
        );
      })}
    </span>
  );
};

const LinkifiedTextInput = ({
  value = '',
  onChange,
  disabled = false,
  tabIndex,
  className = 'm-0',
  rows = 1,
  placeholder
}) => {
  const stringValue = value ?? '';

  const urls = useMemo(() => {
    if (!stringValue) return [];
    const matches = stringValue.match(URL_REGEX) || [];
    return [...new Set(matches.map(raw => cleanUrl(raw)).filter(u => u.url))];
  }, [stringValue]);

  return (
    <div className="w-100">
      <AutoGrowTextArea
        autoComplete="off"
        tabIndex={tabIndex}
        className={className}
        as="textarea"
        size="sm"
        disabled={disabled}
        rows={rows}
        placeholder={placeholder}
        value={stringValue}
        onChange={e => onChange(e.target.value)}
      />
      {urls.length > 0 && (
        <div className="d-flex flex-wrap gap-1 mt-1">
          {urls.map(({ url, href }, idx) => (
            <a
              key={`${href}-${idx}`}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              dir="ltr"
              title={url}
              className="btn btn-outline-primary py-0 px-1 d-inline-flex align-items-center text-truncate"
              style={{ fontSize: '11px', maxWidth: '100%', lineHeight: '18px' }}
              onClick={e => e.stopPropagation()}
            >
              <BoxArrowUpRight size={10} className="me-1 flex-shrink-0" />
              <span className="text-truncate">{url}</span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default LinkifiedTextInput;
